import { IS_LOADING, LIST, DASHBOARDS, USERS } from './AccountsActions';

const INITIAL_STATE = {
  isLoading: true,
  results: undefined,
  page: 0,
  total: 0,
  dashboards: [],
  users: [],
};

const AccountsReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case IS_LOADING: {
      return { ...state, isLoading: action.payload || true };
    }
    case LIST:
      return {
        ...state,
        isLoading: false,
        results: action.payload.results,
        page: action.payload.page,
        total: action.payload.total,
      };
    case DASHBOARDS:
      return {
        ...state,
        isLoading: false,
        dashboards: action.payload,
      };
    case USERS:
      return {
        ...state,
        isLoading: false,
        users: action.payload,
      };
    default:
      return { ...state };
  }
};

export default AccountsReducer;
